module.exports = __webpack_public_path__ + "vn.svg?7e156d1d24f51aca6179f2e54dec5c7c";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/vn.svg
// module id = 1691
// module chunks = 0